export const isLocalEnv = window.location.host?.includes('localhost')
export const apiPrefix = `/api`

export const bmServiceApiUrl = import.meta.env.VITE_API_BM_SERVICE_URL || 'https://api.internal.dev.sullivancotter.com/bm'

export const userApiUrl = import.meta.env.VITE_API_USER_SERVICE_URL || 'https://api.dev.cliniciannexus.com'

// export const applicationSelected = derived(appSelected, globalThis.$appSelected => (globalThis.$appSelected.toLowerCase() === 'app' ? 'app' : 'physician'))

let localUrl = `https://localhost:10000${apiPrefix}`

localUrl = 'https://api.internal.dev.sullivancotter.com/bm'

export const baseURL = isLocalEnv ? localUrl : bmServiceApiUrl
